import { render, staticRenderFns } from "./WaiterSetting.vue?vue&type=template&id=40f7f6fd&scoped=true&lang=pug"
import script from "./WaiterSetting.vue?vue&type=script&lang=ts"
export * from "./WaiterSetting.vue?vue&type=script&lang=ts"
import style0 from "./WaiterSetting.vue?vue&type=style&index=0&id=40f7f6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f7f6fd",
  null
  
)

export default component.exports